"use client"

import React from "react"

export const CallToActionScrollButton = ({ targetId, buttonText, buttonMicroCopy, offset = 90, classProp }) => {
  const handleScroll = () => {
    const element = document.getElementById(targetId)
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
      const scrollToPosition = elementPosition - offset; // stops at top minus offset
      window.scrollTo({ top: scrollToPosition, behavior: "smooth" })
    }
  }

  return (
    <button
      onClick={handleScroll}
      className={`text-white bg-primary hover:bg-primary-deep px-2 py-1 sm:px-4 sm:py-2 sm:font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md ${classProp}`}
      aria-label={buttonMicroCopy || "Call to Action"}
    >
      {buttonText || "Get Started"}
    </button>
  )
}
